import { render, staticRenderFns } from "./SchoolSessionForm.vue?vue&type=template&id=e533efba&scoped=true"
import script from "./SchoolSessionForm.vue?vue&type=script&lang=js"
export * from "./SchoolSessionForm.vue?vue&type=script&lang=js"
import style0 from "./SchoolSessionForm.vue?vue&type=style&index=0&id=e533efba&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e533efba",
  null
  
)

export default component.exports